export const FETCH_LOGIN_USER_REQUEST    =   'FETCH_LOGIN_USER_REQUEST '
export const FETCH_LOGIN_USER_FAILURE   =    'FETCH_LOGIN_USER_FAILURE '
export const FETCH_LOGIN_USER_SUCCESS    =   'FETCH_LOGIN_USER_SUCCESS '
